import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  style: {"enable-background":"new 0 0 61.8 249.5"},
  viewBox: "0 0 61.8 249.5"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M61.7 50.9C33.3 29.5 30.8 0 30.8 0S28.3 29.5 0 50.9M30.8 0v249.4",
  class: "i2083203654__st0"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }